
import { defineComponent } from 'vue'
import FooterContentView from './FooterContentView.vue'

export default defineComponent({
  components: { FooterContentView },
  name: 'Footer',
  data() {
    return {
      certification: require('@/assets/images/certification.png'),
      priceTransparency: require('@/assets/images/price transparency.png'),
      safe: require('@/assets/images/safe.png'),
      professionalTeam: require('@/assets/images/professional team.png'),
      year: new Date().getFullYear()

    }
  },
  props: {
    src: String,
    title: String,
    content: String
  },
  computed: {
    contentList() {
      const contentList = [
        {
          img: this.certification,
          title: '正规资质',
          content: '工信部核准SP资质,移动、电信、联通资深合作伙伴'
        },
        {
          img: this.priceTransparency,
          title: '价格透明',
          content: '短信套餐明码实价，提供每一条短信消费明细记录'
        },
        {
          img: this.safe,
          title: '信息保密',
          content: '所有客户信息严格保密，保护客户信息免遭外泄'
        },
        {
          img: this.professionalTeam,
          title: '售后无忧',
          content: '专业团队提供免费技术支持，7X24小时售后服务'
        }
      ]
      return contentList
    }
  }

})
